app.backtoptopController = app.backtoptopController || {};

app.backtoptopController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.scrollTop();
    },
    
    scrollTop : function () {
        var $topLink = $('.topLink');
        if ($topLink.length > 0) {
            $topLink.on('click', function(){
                $('html, body').animate({ scrollTop:0 }, 500);
            });
        }
    },

};
